import React from 'react';
import './InvoiceSummary.css';

const InvoiceSummary = ({
  calculateSummary,
  taxType,
  sgstRate,
  cgstRate,
  igstRate,
  hasdiscount,
  discount,
  isMobile
}) => {
  return (
    <div className="InvoiceForm__summary-container" style={{width: isMobile ? "100%" : "65%"}}>
      <h2 className="InvoiceForm__section-title">Invoice Summary</h2>
      
      <div className="InvoiceForm__summary-row">
        <div className="InvoiceForm__summary-input-container">
          <span className="InvoiceForm__summary-label">Subtotal:</span>
          <span className="InvoiceForm__summary-value">₹{calculateSummary.subtotal.toFixed(2)}</span>
        </div>
      </div>
      
      {hasdiscount && calculateSummary.discountAmount > 0 && (
        <div className="InvoiceForm__summary-row">
          <div className="InvoiceForm__summary-input-container">
            <span className="InvoiceForm__summary-label">Discount ({discount}%):</span>
            <span className="InvoiceForm__summary-value InvoiceForm__summary-discount">-₹{calculateSummary.discountAmount.toFixed(2)}</span>
          </div>
        </div>
      )}
      
      {hasdiscount && calculateSummary.discountAmount > 0 && taxType !== 'NONE' && (
        <div className="InvoiceForm__summary-row">
          <div className="InvoiceForm__summary-input-container InvoiceForm__summary-taxable">
            <span className="InvoiceForm__summary-label">Taxable Value:</span>
            <span className="InvoiceForm__summary-value">₹{(calculateSummary.subtotal - calculateSummary.discountAmount).toFixed(2)}</span>
          </div>
        </div>
      )}
      
      {taxType === 'SGST_CGST' && (
        <>
          <div className="InvoiceForm__summary-row">
            <div className="InvoiceForm__summary-input-container">
              <span className="InvoiceForm__summary-label">SGST ({sgstRate}%):</span>
              <span className="InvoiceForm__summary-value">₹{calculateSummary.sgstTotal.toFixed(2)}</span>
            </div>
          </div>
          <div className="InvoiceForm__summary-row">
            <div className="InvoiceForm__summary-input-container">
              <span className="InvoiceForm__summary-label">CGST ({cgstRate}%):</span>
              <span className="InvoiceForm__summary-value">₹{calculateSummary.cgstTotal.toFixed(2)}</span>
            </div>
          </div>
        </>
      )}
      
      {taxType === 'IGST' && (
        <div className="InvoiceForm__summary-row">
          <div className="InvoiceForm__summary-input-container">
            <span className="InvoiceForm__summary-label">IGST ({igstRate}%):</span>
            <span className="InvoiceForm__summary-value">₹{calculateSummary.igstTotal.toFixed(2)}</span>
          </div>
        </div>
      )}
      
      {taxType !== 'NONE' && (
        <div className="InvoiceForm__summary-row">
          <div className="InvoiceForm__summary-input-container">
            <span className="InvoiceForm__summary-label">Total Tax:</span>
            <span className="InvoiceForm__summary-value">₹{calculateSummary.totalTax.toFixed(2)}</span>
          </div>
        </div>
      )}
      
      <div className="InvoiceForm__summary-row">
        <div className="InvoiceForm__summary-input-container InvoiceForm__summary-total">
          <span className="InvoiceForm__summary-label">Total Amount:</span>
          <span className="InvoiceForm__summary-value">₹{calculateSummary.total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSummary;